import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogOut, ExternalLink } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import { Logo } from "../../components/site/Logo";
import { ProjectsManager } from "./ProjectsManager";
import { Inquiries } from "./Inquiries";
import { api } from "../../lib/api";

export default function Admin() {
  const [user, setUser] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { setUser(false); nav("/admin/login"); });
  }, [nav]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    toast.success("Disconnessa");
    nav("/admin/login");
  };
  if (!user) return <div className="min-h-screen flex items-center justify-center bg-cream text-ash">Caricamento…</div>;

  return (
    <main data-testid="admin-dashboard" className="min-h-screen bg-cream">
      <header className="border-b border-stone bg-cream/90 backdrop-blur sticky top-0 z-30">
        <div className="mx-auto max-w-6xl px-5 py-4 flex items-center justify-between gap-4">
          <Link to="/" data-testid="admin-home-link"><Logo /></Link>
          <div className="flex items-center gap-2">
            <Link to="/" className="hidden sm:inline-flex items-center gap-1.5 text-sm text-ink/75 hover:text-cypress px-3"><ExternalLink className="w-4 h-4" /> Vedi sito</Link>
            <button data-testid="admin-logout-button" onClick={logout} className="inline-flex items-center gap-1.5 rounded-full border border-stone px-4 py-2 text-sm hover:border-cypress"><LogOut className="w-4 h-4" /> Esci</button>
          </div>
        </div>
      </header>
      <div className="mx-auto max-w-6xl px-5 py-10">
        <h1 className="font-serif text-4xl sm:text-5xl text-ink">Ciao {user.name || "Annette"}</h1>
        <p className="mt-2 text-ash">Aggiorna i tuoi lavori e leggi le richieste dei futuri sposi.</p>
        <Tabs defaultValue="wedding" className="mt-8">
          <TabsList className="bg-sand rounded-full p-1 h-auto flex-wrap">
            <TabsTrigger value="wedding" data-testid="admin-tab-wedding" className="rounded-full px-4 py-2 data-[state=active]:bg-cypress data-[state=active]:text-cream">Portfolio Wedding</TabsTrigger>
            <TabsTrigger value="shop" data-testid="admin-tab-shop" className="rounded-full px-4 py-2 data-[state=active]:bg-cypress data-[state=active]:text-cream">Creazioni Negozio</TabsTrigger>
            <TabsTrigger value="inquiries" data-testid="admin-tab-inquiries" className="rounded-full px-4 py-2 data-[state=active]:bg-cypress data-[state=active]:text-cream">Richieste</TabsTrigger>
          </TabsList>
          <TabsContent value="wedding" className="mt-8"><ProjectsManager kind="wedding" /></TabsContent>
          <TabsContent value="shop" className="mt-8"><ProjectsManager kind="shop" /></TabsContent>
          <TabsContent value="inquiries" className="mt-8"><Inquiries /></TabsContent>
        </Tabs>
      </div>
    </main>
  );
}
